module.exports = __webpack_public_path__ + "img/maldives.2c73a172.png";